
import {
  FIRST_NAME_SENDER_SINGLE,
  LAST_NAME_SENDER_SINGLE,
  NATIONAL_CODE_SENDER_SINGLE,
  POSTAL_CODE_SENDER_SINGLE,
  MOBILE_NUMBER_SENDER_SINGLE,
  PHONE_NUMBER_SENDER_SINGLE,
  ADDRESS_SENDER_SINGLE,
  EMAIL_SENDER_SINGLE,
  COMPANY_SENDER_SINGLE,
  LAT_SENDER_SINGLE,
  LNG_SENDER_SINGLE,
  CITY_NAME_SENDER_SINGLE,
  CITY_ID_SENDER_SINGLE,
  STATE_NAME_SENDER_SINGLE,
  STATE_ID_SENDER_SINGLE,
  NEED_SENDER_SINGLE,
} from "../../Types";

export const setFirstNameSender = (payload) => {
  return {
    type: FIRST_NAME_SENDER_SINGLE,
    payload: payload,
  };
};
export const setLastNameSender = (payload) => {
  return {
    type: LAST_NAME_SENDER_SINGLE,
    payload: payload,
  };
};
export const setNationalCodeSender = (payload) => {
  return {
    type: NATIONAL_CODE_SENDER_SINGLE,
    payload: payload,
  };
};
export const setPostalCodeSender = (payload) => {
  return {
    type: POSTAL_CODE_SENDER_SINGLE,
    payload: payload,
  };
};
export const setAddressSender = (payload) => {
  return {
    type: ADDRESS_SENDER_SINGLE,
    payload: payload,
  };
};
export const setMobileNumberSender = (payload) => {
  return {
    type: MOBILE_NUMBER_SENDER_SINGLE,
    payload: payload,
  };
};
export const setPhoneNumberSender = (payload) => {
  return {
    type: PHONE_NUMBER_SENDER_SINGLE,
    payload: payload,
  };
};
export const setCityNameSender = (payload) => {
  return {
    type: CITY_NAME_SENDER_SINGLE,
    payload: payload,
  };
};
export const setCityIDSender = (payload) => {
  return {
    type: CITY_ID_SENDER_SINGLE,
    payload: payload,
  };
};
export const setStateNameSender = (payload) => {
  return {
    type: STATE_NAME_SENDER_SINGLE,
    payload: payload,
  };
};
export const setStateIDSender = (payload) => {
  return {
    type: STATE_ID_SENDER_SINGLE,
    payload: payload,
  };
};
export const setLatSender = (payload) => {
  return {
    type: LAT_SENDER_SINGLE,
    payload: payload,
  };
};
export const setLngSender = (payload) => {
  return {
    type: LNG_SENDER_SINGLE,
    payload: payload,
  };
};
export const setEmailSender = (payload) => {
  return {
    type: EMAIL_SENDER_SINGLE,
    payload: payload,
  };
};
export const setCompanySender = (payload) => {
  return {
    type: COMPANY_SENDER_SINGLE,
    payload: payload,
  };
};
export const setNeedSender = (payload) => {
  return {
    type: NEED_SENDER_SINGLE,
    payload: payload,

  };
};
